import { CLIMBING_STYLES } from '../constants.js';

export const calculateAscentTypeStats = (data, climbingStyle = CLIMBING_STYLES.SPORT) => {
  if (!data?.length) return [];
  
  const ascentCounts = {};
  
  data.forEach(ascent => {
    const type = ascent['Ascent Type'];
    if (!ascentCounts[type]) {
      ascentCounts[type] = 0;
    }
    ascentCounts[type]++;
  });
  
  return Object.entries(ascentCounts)
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);
};
